import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Packages
import { Button, Col, Container } from 'react-bootstrap';

// Components
import GlobalConfigForm from '../config/GlobalConfigForm';
import GlobalConfigTable from '../config/GlobalConfigTable';

// Actions
import { get_organizations } from '../../../../actions/organizationActions';
import { get_all_apps } from '../../../../actions/appActions';
import { get_all_languages } from '../../../../actions/languageActions';
import { get_global_config } from '../../../../actions/globalActions';

// Hooks
import useDidMountEffect from '../../../../hooks/useDidMountEffect';

const Global = () => {
	const dispatch = useDispatch();

	const { global_config_loading, global_config, global_errors } = useSelector(state => state.global);
	
	const [showGlobalConfigModal, setShowGlobalConfigModal] = useState(false);
	const [start, setStart] = useState(0);
	const [end, setEnd] = useState(9);
	const [limit] = useState(20);

	useEffect(() => {
		dispatch(get_organizations());
		dispatch(get_all_apps());
		dispatch(get_all_languages());
	}, []);

	useEffect(() => {
		const filters = {
			skip: start,
			limit: limit
		};
		dispatch(get_global_config(filters));
	}, [start]);

	const createGlobalConfig = () => {
		setShowGlobalConfigModal(true);
	}

	const onHide = () => {
		setShowGlobalConfigModal(false);
	}

	return (
		<Container className='mt-3 pb-5'>
			<GlobalConfigForm
				show={showGlobalConfigModal}
				onHide={onHide}
				filters={{ skip: start, limit: limit }}
			/>

			<Container className='wrapper-container px-0 mb-3'>
				<Col className='title'>
					<h2 className='text-center'>Global</h2>
				</Col>
				<Col className='icons-btns'>
					<Container className='d-flex align-items-center justify-content-end px-0'>
						<Button className='submit-btn' onClick={createGlobalConfig}>
							<strong>Create Configuration</strong>
						</Button>
					</Container>
				</Col>
			</Container>

			<p className='text-muted'>Total configurations: {global_config.count}</p>
			<GlobalConfigTable
				tableLoading={global_config_loading}
				dataCount={global_config.count}
				tableData={global_config.configurations}
				start={start}
				setStart={setStart}
				end={end}
				setEnd={setEnd}
				limit={limit}
			/>
		</Container>
	)
}

export default Global;
